import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Error404 from '../modules/Error404';
import Error403 from '../modules/Error403';
import MyCourseInnerBundle from "../modules/studentDashboard/courseinnerbundle";
import MyCourseInnerEvents from "../modules/studentDashboard/courseinnerevent";
import HomePage from "../modules/studentDashboard/homepage";
import CourseListing from "../modules/studentDashboard/courselisting";
import CourseCurriculumOverview from "../modules/studentDashboard/coursecurriculumoverview";
import CourseEventsListing from "../modules/studentDashboard/courseeventslisting";
import BulkLearnerEnroll from "../modules/studentDashboard/BulkLearnerEnroll";
import CartReact from "../components/student-dashboard/cart-react";
import EventInner from "../modules/studentDashboard/eventinner";
import Slug from "../modules/Slug";
import CourseBundleDetailsPage from "../modules/studentDashboard/coursebundledetails";
import EnquiryFormPage from '../modules/studentDashboard/EnquiryFormPage';
import CustompageCourseListing from "../modules/studentDashboard/CustompageCourseListing";
import Custom_page from "../components/Page/Custom_page";
import HelpForm from "../modules/studentDashboard/helpForm";
import PublicProfile from "../modules/studentDashboard/profile";
import PackageListing from "../modules/studentDashboard/packagelisting";
import ProtectRoute from "../middlewares/ProtectRoute";
import StudentDashboard from "../modules/afterLogin/studentDashboard";
import Courses from "../modules/afterLogin/studentDashboard/coursesListing";
import Bundles from "../modules/afterLogin/studentDashboard/bundlesListing";

import ClientLayout from "../layout/DashboardLayout";
import CourseDetailsPage from "../modules/afterLogin/studentDashboard/CourseDetailsPage";
import BundleDetails from "../modules/afterLogin/studentDashboard/BundleDetails";
import EventsListing from "../modules/afterLogin/studentDashboard/EventsListing";
import EventDetails from "../modules/afterLogin/studentDashboard/EventDetails";
import Settings from "../modules/afterLogin/studentDashboard/Settings";
import EventsJoinLanding from "../modules/afterLogin/studentDashboard/EventJoinLanding";
import DmsLanding from "../modules/afterLogin/studentDashboard/dms/DmsLanding";
import StudentProfile from "../modules/afterLogin/studentDashboard/StudentProfile";
import TransferOrder from "../modules/afterLogin/studentDashboard/TransferOrder";
import TransferOrderSuccess from "../modules/afterLogin/studentDashboard/TransferOrderSuccess";
import TransferOrderFailed from "../modules/afterLogin/studentDashboard/TransferOrderFailed";
import MyOrder from "../modules/afterLogin/studentDashboard/MyOrder";
import RemovalFromWaitingList from "../modules/afterLogin/RemovalFromWaitingList";
import InvalidSubscription from  "../modules/afterLogin/InvalidSubscription";
import DmsResources from "../modules/afterLogin/studentDashboard/dms/DmsResources";
import ArchivesListing from "../modules/afterLogin/studentDashboard/ArchivesListing";
import ArchivesDetails from "../modules/afterLogin/studentDashboard/ArchiveDetails";
import CompleteProfile from "../modules/afterLogin/studentDashboard/CompleteProfile";
import MessageFullWidthBlock from "../modules/afterLogin/MessageFullWidthBlock";

const basename = ""; //process.env.REACT_APP_BASENAME || '';

export default (
  <Router basename={basename}>
    <Routes>
      <Route path="/courses/course-inner-bundle" element={<MyCourseInnerBundle />} />
      <Route path="/courses/course-inner-events" element={<MyCourseInnerEvents />} />
      <Route path="/error404" element={<Error404 />} />
      <Route path="/error403" element={<Error403 />} />
      <Route index element={<Slug />} />
      <Route path="/course/listing" element={<CourseListing />} />
      <Route path="/packages-list" element={<PackageListing />} />
      <Route path="/cart_react" element={<CartReact />} />
      <Route path="/course-curriculum" element={<CourseCurriculumOverview />} />
      <Route path="/course-events-listing" element={<CourseEventsListing />} />
      <Route path="/events/event-inner" element={<EventInner />} />
      <Route path="/bulk_learners_enroll/:id/:type" element={<BulkLearnerEnroll />} />
      <Route path="/enquiry" element={<EnquiryFormPage />} />
      <Route path="/enquiry-form" element={<HelpForm />} />
      <Route path="/:slug" element={<Slug />} />
      <Route path="/course-bundle-details" element={<CourseBundleDetailsPage />} />
      <Route path="/custom_course_list" element={<CustompageCourseListing />} />
      <Route path="/public-profile/:slug" element={<PublicProfile />} />
      {/* Protected */}
      <Route path="/" element={<ProtectRoute />}>
          <Route path="*" element={<ClientLayout><Error404 className="errow-with-nav w-100 mx-auto"/></ClientLayout>} />
          <Route path="student-dashboard" element={<ClientLayout><StudentDashboard/></ClientLayout>} />
          <Route path="student-dashboard/courses" element={<ClientLayout><Courses/></ClientLayout>} />
          <Route path="student-dashboard/courses/detail/:slug" element={<ClientLayout><CourseDetailsPage/></ClientLayout>} />
          <Route path="student-dashboard/bundles" element={<ClientLayout><Bundles/></ClientLayout>} />
          <Route path="student-dashboard/bundles/:slug" element={<ClientLayout><BundleDetails/></ClientLayout>} />
          <Route path="student-dashboard/events" element={<ClientLayout><EventsListing/></ClientLayout>} />
          <Route path="student-dashboard/events/event-details" element={<ClientLayout><EventDetails/></ClientLayout>} />
          <Route path="student-dashboard/dms" element={<ClientLayout><DmsLanding/></ClientLayout>} />
          {/* <Route path="student-dashboard/dms/resources" element={<ClientLayout><DmsResources/></ClientLayout>} /> */}
          <Route path="student-dashboard/archives" element={<ClientLayout><ArchivesListing/></ClientLayout>} />
          <Route path="student-dashboard/archives/detail/:id" element={<ClientLayout><ArchivesDetails/></ClientLayout>} />
          <Route path="student-dashboard/settings" element={<ClientLayout><Settings/></ClientLayout>} />
          <Route path="student-dashboard/events/:slug" element={<ClientLayout><EventDetails/></ClientLayout>} />
          <Route path="student-dashboard/learner-profile"  element={<ClientLayout><StudentProfile/></ClientLayout>} />
          <Route path="student-dashboard/complete-profile"  element={<ClientLayout><CompleteProfile/></ClientLayout>} />
          <Route path="student-dashboard/transfer/:hashId"  element={<ClientLayout><TransferOrder/></ClientLayout>} />
          <Route path="student-dashboard/transfer/success"  element={<ClientLayout><TransferOrderSuccess/></ClientLayout>} />
          <Route path="student-dashboard/transfer/failed"  element={<ClientLayout><TransferOrderFailed/></ClientLayout>} />
          <Route path="student-dashboard/cancellation/:hashId"  element={<ClientLayout><MyOrder/></ClientLayout>} />
          <Route path="student-dashboard/removed-from-waiting-list"  element={<ClientLayout><RemovalFromWaitingList/></ClientLayout>} />
          <Route path="student-dashboard/invalid-subscription"  element={<ClientLayout><InvalidSubscription/></ClientLayout>} />
      </Route>
    </Routes>
  </Router>
);

